/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_HeadingInputs */

const et_contact_heading = /** @type {(inputs: Contact_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alusta kohe paari minutiga.`)
};

const en_contact_heading = /** @type {(inputs: Contact_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started in just a few minutes.`)
};

/**
* | output |
* | --- |
* | "Get started in just a few minutes." |
*
* @param {Contact_HeadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_heading = /** @type {((inputs?: Contact_HeadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_HeadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_heading(inputs)
	return en_contact_heading(inputs)
});